<template>
    <q-page class="q-pa-md">
        <q-table class="deluxe-list"
                 :loading="loading"
                 :columns="columns"
                 :visible-columns="columnsVisible"
                 :data="dataSource"
                 :filter="filter"
                 row-key="Id"
                 :pagination.sync="pagination"
                 :rows-per-page-options="[ 5, 10, 15, 25, 50, 100 ]"
                 @request="onRequest"
                 wrap-cells>
            <template v-slot:top>
                <q-toolbar v-if="screenTitle">
                    <div class="q-table__title">
                        {{ screenTitle }}
                    </div>

                    <q-space></q-space>
                </q-toolbar>

                <q-toolbar>
                    <q-input outlined v-model="filter"
                             dense clearable clear-icon="close"
                             placeholder="Search" debounce="300"
                             style="width:250px" class="q-mr-xs">
                        <template v-slot:prepend>
                            <q-icon name="search"></q-icon>
                        </template>
                    </q-input>

                    <q-btn round dense flat color="primary" icon="filter_alt" @click="onAdvancedFilterActionClick">
                        <q-tooltip>
                            ADVANCED FILTER
                        </q-tooltip>
                    </q-btn>
                    <q-btn round dense flat color="primary" icon="clear" @click="onClearFilterActionClick" v-if="true && (filter || advancedFilter)">
                        <q-tooltip>
                            CLEAR ALL FILTERS
                        </q-tooltip>
                    </q-btn>
                    <q-btn round dense flat color="primary" icon="refresh" @click="refreshScreen">
                        <q-tooltip>
                            REFRESH
                        </q-tooltip>
                    </q-btn>

                    <q-space></q-space>

                    <div class="q-gutter-xs">

                    </div>
                </q-toolbar>
                <q-toolbar>
                    <div>Total time spent, hrs: {{ model.TotalTimeSpent }}</div>
                    <q-space></q-space>
                </q-toolbar>
            </template>
            <template v-slot:body-cell-Actions="props">
                <q-td :props="props" auto-width>
                    <div class="q-gutter-xs">
                        <q-btn label="Open"
                               color="primary"
                               @click="onOpenTicketActionClick(props.key, props.rowIndex, props.row)">

                        </q-btn>

                    </div>
                </q-td>
            </template>


        </q-table>
    </q-page>
</template>

<style>
    
</style>

<script>
    export { default } from './freshdeskticketlistmodel-list-screen.js'
</script>